"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawerContentStyle = exports.Mask = exports.DrawerContent = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _mediaQueries = _interopRequireDefault(require("../../../mediaQueries"));

var _index = require("./index");

var _templateObject;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var drawerWidth = '34.5rem';

var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__Container",
  componentId: "sc-vhzxni-0"
})(["z-index:10;"]);

exports.Container = Container;

var Mask = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__Mask",
  componentId: "sc-vhzxni-1"
})(["position:fixed;left:0;top:0;right:0;bottom:0;opacity:0.25;background:rgba(0,0,0,0.6);transform:translateX(-100%);transition:opacity ", "ms;&.fade-in-appear{opacity:0.75;}&.fade-in-enter-done{transform:translateX(0);opacity:0.75;}"], function () {
  return _index.ANIMATION_SPEED_ENTER;
});

exports.Mask = Mask;
var drawerContentStyle = /*#__PURE__*/(0, _styledComponents.css)(["position:fixed;top:0;right:0;bottom:0;padding:", ";max-width:100%;overflow-x:hidden;overflow-y:auto;background-color:", ";box-shadow:0 0 ", " 0 rgba(0,0,0,0.5);", ""], function (p) {
  return p.theme.tokens.spacing05;
}, function (p) {
  return p.theme.colorBackgroundDrawer;
}, function (p) {
  return p.theme.tokens.spacing06;
}, _mediaQueries["default"].smUp(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    padding: ", ";\n  "])), function (p) {
  return p.theme.tokens.spacing08;
}));
exports.drawerContentStyle = drawerContentStyle;

var DrawerContent = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__DrawerContent",
  componentId: "sc-vhzxni-2"
})(["", " width:", ";transform:translateX(", ");&.slide-in-enter-active{transition:transform ", "ms ease-out;transform:translateX(0);}&.slide-in-enter-done{transform:translateX(0);}&.slide-in-exit{transform:translateX(0);}&.slide-in-exit-active{transform:translateX(", ");transition:transform ", "ms ease-in;}"], drawerContentStyle, drawerWidth, drawerWidth, function () {
  return _index.ANIMATION_SPEED_ENTER;
}, drawerWidth, function () {
  return _index.ANIMATION_SPEED_EXIT;
});

exports.DrawerContent = DrawerContent;